import { SpinnerIcon } from 'primitives/icons'
import { tw } from 'utils/classnames'

export function AnimatedSpinnerIcon(props: React.ComponentProps<'img'>) {
  return (
    <img
      src={SpinnerIcon.src}
      width="16"
      height="16"
      {...props}
      className={tw('h-[23px] w-[23px] animate-spin [filter:invert(1)]', props.className)}
    />
  )
}
